import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

export default function MainTable({ rows, columns, loading }) {
  const [pageSize, setPageSize] = useState(5);

  return (
    <div style={{ width: "100%", background: "white" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id} // Ensure unique row IDs
        rowHeight={55}
        autoHeight // Automatically expand height
        pageSize={pageSize}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        rowsPerPageOptions={[5, 10]} // "All" option (total rows count)
        pagination
        components={{ Toolbar: GridToolbar }}
        loading={loading}
        sx={{
          borderRadius: "15px",
          background: "#FFFFFF",
          boxShadow: "0px 0px 10px rgba(116, 128, 135, 0.07)",
          "& .MuiDataGrid-columnHeaders": {
            color: "#65708D",
            fontSize: "11px",
          },
          "& .MuiDataGrid-row": {
            "&:hover, &.Mui-hovered": {
              background: "#F2FBFF",
            },
          },
        }}
      />
    </div>
  );
}